// extracted by mini-css-extract-plugin
export default {"header":"Header_header__vvzfT","widget":"Header_widget__E4rp+","logo":"Header_logo__AmMwj"};